module.exports = __webpack_public_path__ + "img/unmute.f64be2ce.svg";